<style scoped>
.invite-friend-form-modal ::v-deep .invite-friend-form-wrapper {
    max-height: calc(100vh - 8rem);
    overflow: auto;
}

.success-msg {
    border-width: 2px;
    border-color: #70ad47;
    background-color: #e2f0d9;
    @apply text-center;
}
</style>
<template>
    <modal
        type="custom"
        class="modal-2xl invite-friend-form-modal"
        @backdrop="$emit('hide')"
    >
        <inviteFriendForm class="-mt-4 sm:mt-0" :formWrapper="bubbleBoxWrapper">
            <template #buttons="{save, saveStatus, isReactivate}">
                <div
                    v-if="saveStatus === 'success'"
                    class="success-msg mt-4 py-2"
                >
                    {{
                        isReactivate
                            ? '親友會員帳號已經重新啓用。請通知親友可以繼續使用此帳號'
                            : '已發送邀請電郵。請通知親友按電郵連結完成登記'
                    }}
                </div>
                <div class="flex mt-4 sm:pb-4">
                    <button
                        class="btn btn-white mr-4 ml-auto px-8 sm:px-12"
                        @click="$emit('hide')"
                    >
                        {{ $t('common.back') }}
                    </button>
                    <loadingButton
                        class="btn btn-primary sm:px-8"
                        :status="saveStatus"
                        @click="save"
                        @successShown="$emit('success')"
                    >
                        {{ $t('friend.invitation.invite.friend') }}
                    </loadingButton>
                </div>
            </template>
        </inviteFriendForm>
    </modal>
</template>

<script>
import bubbleBox from '@/components/bubbleBox.vue';
import modal from './modal.vue';
import inviteFriendForm from './inviteFriendForm.vue';
import loadingButton from './loadingButton';
import img2s112 from '../assets/img/2-112.png';

const bubbleBoxWrapper = {
    name: 'bubbleBoxWrapper',
    render(h) {
        return h(
            bubbleBox,
            {
                props: {
                    greetText: this.$t('friend.invitation.greet'),
                    greetTextClass: 'text-darkGrayishBlue',
                    image: img2s112
                }
            },
            [h('div', { class: 'pt-4 px-4 sm:px-8' }, this.$slots.default)]
        );
    }
};

export default {
    components: {
        modal,
        inviteFriendForm,
        loadingButton
    },
    computed: {
        bubbleBoxWrapper() {
            return bubbleBoxWrapper;
        }
    }
};
</script>
